import { FormatTypes } from '../../constants/templateDictionaries';
import getJournalInitialState from './getJournalInitialState';
import getResumeInitialState from './getResumeInitialState';
import getCoverLetterInitialState from './getCoverLetterInitialState';

export default (params) => {
  const { formatType } = params;
  let initialData;
  if (formatType === FormatTypes.JOURNAL) {
    initialData = getJournalInitialState(params);
  } else if (formatType === FormatTypes.RESUME) {
    initialData = getResumeInitialState(params);
  } else if (formatType === FormatTypes.COVER_LETTER) {
    initialData = getCoverLetterInitialState(params);
  }

  return initialData;
};
